import { useAppDispatch, useAppSelector, useHandlePageNavigate } from "./hooks";
import {
  pullNeighborhoodReportByLocationAsync,
  pullNeighborhoodSearchAsync,
  selectNeighborhoodReportStatus,
  selectNeighborhoodSearchStatus,
  selectAllReportNotesList,
} from "../features/reports/reportsSlice";
import { useLocation } from "react-router-dom";

import {
  PullNeighborhoodReportParams,
  PullNeighborhoodSearchParams,
} from "../features/reports/reportTypes";
import {
  setNeighborhoodNameSearch,
  setNeighborhoodReportSearch,
} from "../features/multisearch/multisearchSlice";
import { useGetSpecificReportNotesDispatch } from "./notesHook";
import { CombinedNoteParams } from "../features/reports/reportTypes";
import { getSpecificReportNotesParamBuilder } from "../utils";

type UseNeighborhoodReportHook = () => ({
  addressSearch,
  searchMethod,
}: PullNeighborhoodReportParams) => void;

/* Pull Neighborhood Report */
const useNeighborhoodReportDispatch: UseNeighborhoodReportHook = () => {
  const dispatch = useAppDispatch();
  const reportStatus = useAppSelector(selectNeighborhoodReportStatus);
  const pageNavigate = useHandlePageNavigate();
  const location = useLocation();

  const allReportNotesList = useAppSelector(selectAllReportNotesList);
  const getSpecificReportNotes = useGetSpecificReportNotesDispatch();

  const pullNeighborhoodReport = ({
    addressSearch,
    searchMethod,
  }: PullNeighborhoodReportParams) => {
    if (reportStatus === "loading") return;
    dispatch(
      pullNeighborhoodReportByLocationAsync({ addressSearch, searchMethod }),
    );
    dispatch(setNeighborhoodReportSearch({ addressSearch, searchMethod }));

    //getSpecificReportNotes if neighborhood notes exist and notes for a specific neighborhood exist
    if (
      allReportNotesList?.some(
        notes =>
          notes &&
          notes.reportType === "neighborhood" &&
          notes.addressLine1 === addressSearch.address,
      ) &&
      addressSearch
    ) {
      let neighborhoodReportParams = {
        reportType: "neighborhood",
        reportParams: {
          addressLine1: addressSearch.address || "",
          addressLine2: addressSearch.addressLine2 || "",
          city: addressSearch.city || "",
          state: addressSearch.state || "",
          zip: addressSearch.zipCode || "",
        },
      } as CombinedNoteParams;
      getSpecificReportNotes(neighborhoodReportParams);
    }

    if (location.pathname !== "/neighborhood-report") {
      pageNavigate("/neighborhood-report");
    } else {
      window.scroll(0, 0);
    }
  };
  return pullNeighborhoodReport;
};

type UseNeighborhoodSearchHook = () => ({
  firstName,
  lastName,
}: PullNeighborhoodSearchParams) => void;

/* Pull Neighborhood Search */
const useNeighborhoodSearchDispatch: UseNeighborhoodSearchHook = () => {
  const dispatch = useAppDispatch();
  const reportStatus = useAppSelector(selectNeighborhoodSearchStatus);
  const pageNavigate = useHandlePageNavigate();
  const location = useLocation();

  const pullNeighborhoodReport = ({
    firstName,
    lastName,
  }: PullNeighborhoodSearchParams) => {
    if (reportStatus === "loading") return;
    dispatch(pullNeighborhoodSearchAsync({ firstName, lastName }));
    dispatch(setNeighborhoodNameSearch({ firstName, lastName }));

    if (location.pathname !== "/neighborhood-search") {
      pageNavigate("/neighborhood-search");
    } else {
      window.scroll(0, 0);
    }
  };
  return pullNeighborhoodReport;
};

export { useNeighborhoodReportDispatch, useNeighborhoodSearchDispatch };
